<template>
    <b-modal :id="$id('affectationFactorModal')" :visible="visible" scrollable centered no-close-on-backdrop body-class="pt-0"  >
        <template #modal-header="{ close }">
            <b-row class="w-100 p-0 m-0 h-100 " align-v="center">
                <b-col cols="10" class="text-left">
                    {{ $t('SelectionFactorTitle', { name: FactorLabel })}}
                    <!-- <h6>{{ $t('FactorAssignments', { name : FactorLabel }) }} Affectations du facteur {{selectedFactor.Label}}</h6> -->
                </b-col>
                <b-col cols="2" class=" pr-0 p-1 pl-4 text-right">
                    <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close(); modalClosed()" v-b-tooltip.hover :title="$t('Cancel')" /> <!-- Fermer -->
                </b-col>
            </b-row>
        </template>
        
        <b-row align-v="center" >
            <b-table-simple responsive fixed class="m-0 p-0 align-middle">
                <!-- Permet d'appliquer des styles sur un groupe de colonnes (ici on applique un style css pour gérer la largeur du logo et de l'icone '' ) -->
                <colgroup>
                    <col style="width: 3rem;">
                    <col>
                    <col style="width: 3rem;">
                </colgroup>
                <!-- On passe par la méthode getPageSelections() pour la prop FactorSelection afin obtenir le noeud de la page courante et non celui de la liste complète -->
                <FactorSelectionNode v-for="(factorSelection, index) in getPageSelections()" :key="factorSelection.NodeId" :FactorSelection.sync="getPageSelections()[index]"
                    :CheckedNodeIds="factorSelection.Filters" 
                    v-on="$listeners" />
                    <b-row class="p-1">
                        <b-col>
                            <b-pagination :total-rows="totalRows()" v-model="currentPage" :per-page="perPage" class="p-0 m-0" :style="generateVariantStyle(Variant)" >
                                <template #page="{ page }" >
                                    {{ page }}
                                </template>
                            </b-pagination>
                        </b-col>
                    </b-row>
                
            </b-table-simple>
        </b-row>

        <template #modal-footer="{ close }">
            <b-button pill :variant="'outline-' + Variant" @click="close(); modalClosed();">{{ $t('Close') }}</b-button>
        </template>
    </b-modal>
</template>

<script lang="ts">
    import { Prop } from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import FactorSelectionNode from './FactorSelectionNode.vue';
    import FactorSelection from '@/types/Config/Factor/Benchmarking/FactorSelection';
    import { ThemeUtils } from '@/components/commons/Utils';
    
    import locales from './locales/FactorSelectionNodes.json';

    @Component({
        components: {
            FactorSelectionNode
        },
        i18n : { messages : locales }
    })
    export default class FactorSelectionNodes extends ThemeUtils {
        /** Variant de couleur à appliquer sur le composant */
		@Prop({ default: () => "secondary"})
		public Variant!: string;
        
        private visible: boolean = true;

        @Prop()
        public FactorSelections: FactorSelection[];

        /** Nom du facteur */
        @Prop()
        public FactorLabel!: string;

        //#region Pagination
        /** Nombre d'éléments par page */
		private perPage: number = 10;

        /** Numéro de la page actuelle */
        private currentPage : number = 1;

        /** Retourne le nombre de lignes totales du tableau */
        private totalRows(): number {
            return this.FactorSelections.length;
        }

        /** Retourne la liste des éléments à afficher en fonction de la page actuelle et le nombre d'éléments par page*/
        private getPageSelections() : FactorSelection[]{
            return this.FactorSelections.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
        }
        //#endregion Pagination

        /**
         * Permet la fermeture de la modal via un evenement
         */
         private modalClosed() {
            this.$emit('CloseSelectionEvent');
        }

        created(){
            this.visible = true;
        }
    }
</script>

<style scoped>
/** Pour que la page active prenne en compte la couleur de Variant */
    :deep(.page-item.active .page-link) {
		background-color: var(--Variant) !important;
	}

    :deep(.page-link:hover) {
		background-color: var(--VariantLight) !important;
	}
</style>